import { useContext } from 'react';
import { MappingChartsDataContext } from '../contexts/MappingChartsDataContext';

export const useMappingChartsDataContext = () => {
    return useContext(MappingChartsDataContext);
};
